import React from "react";
import { connect } from "react-redux";
import {
  getEmpresas,
  activarDesactivarEmpresa,
} from "../empresas/EmpresaService";
import "../../styles/Empresa.css";
import DocumentDialogContent from "./Empresa";
import EmpresaDatos from "../empresas/EmpresaDatos";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import { Modal, Button, Col, Container, Row } from "react-bootstrap";
import visibility from "../../styles/icons/visibility.svg";
import editIcon from "../../styles/icons/edit.svg";
import ExclamacionIcon from "../../styles/icons/exclamation-circle.svg";
import { Link } from "react-router-dom";
import ModalDetalleConfiguraciones from "../componentes/modales/ModalDetalleConfiguraciones";
import doNotdisturb from "../../styles/icons/do_not_disturb.svg";
import restore from "../../styles/icons/settings_backup_restore.svg";

class Empresas extends React.Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const estado = location && location.state ? location.state : {};
    this.state = {
      dialogTitle: "Registrar nueva Empresa",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedEmpresa: {
        nombre: "",
        direccion: "",
        ruc: "",
        activo: true,
        id: "",
      },

      administradoresAsociados: [],
      gestoresAsociados: [],

      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      dialogDesactivarEmpresa: false,
      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",
      loading: true,
      search: "",
      pageSize: 10,
    };
    this.tableRef = React.createRef();
    this.modalRef = React.createRef();
  }

  handleDialog = (value, mensaje = "") => {
    if (value === false) {
      if (mensaje !== "") {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: mensaje,
        });
      }
    }
    this.setState({ dialogIsOpen: value });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  handleDialogVerDatos = (value, empresaSeleccionada = null) => {
    this.setState({ dialogIsOpenVerDatos: value }, () => {
      if (value && empresaSeleccionada && this.modalRef) {
        this.modalRef.current.cargarDetalles(empresaSeleccionada);
      }
    });
  };

  handleDialogDesactivarEmpresa = (estadoDialogo) => {
    this.setState({
      dialogDesactivarEmpresa: estadoDialogo,
    });
  };

  handleNewEmpresa = () => {
    this.props.history.push('/admin/empresas/add')
  };

  handleDesactivarEmpresa = (empresa, estado) => {
    activarDesactivarEmpresa(empresa.id, estado).then((resp) => {
      if (!resp.error) {
        this.fetchEmpresa(0, this.state.pageSize, "");
        this.handleDialogDesactivarEmpresa(false);
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: resp.mensaje,
        });
      } else {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: "Ocurrio un error al realizar la operacion",
          severity: "danger",
        });
      }
    });
  };


  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchEmpresa(newPage, this.state.pageSize, "");
      });
    }
  }
  componentDidMount() {
    this.fetchEmpresa(0, this.state.pageSize, "");
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchEmpresa(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchEmpresa(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">
              {i + 1}
            </a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">
              1
            </a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">
              {i + 1}
            </a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">
              {totalPages}
            </a>
          </li>
        );
      }
    }

    return pages;
  }

  fetchEmpresa(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getEmpresas(page, pageSize, search).then(() => {
      this.setState({
        numeroPatronal: this.props.empresaData.empresas,
        page: this.props.empresaData.page,
        totalCount: this.props.empresaData.totalCount,
        totalPages: Math.ceil(this.props.empresaData.totalCount / pageSize),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchEmpresa(0, this.state.pageSize, this.state.search);
    });
  };

  render() {
    return (
      <div>
        {/*
          <MensajeFlash
            mensaje={this.state.mensajeFlash}
            severity={"success"}
            open={this.state.mostrarMensajeFlash}
            handleClose={this.handleCloseMensajeFlash}
          />
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.dialogIsOpen}
            onHide={this.handleDialog}
            backdrop="static"
            keyboard="false"
          >
            <DocumentDialogContent
              empresa={this.state.selectedEmpresa}
              handleClose={this.handleDialog}
              type={this.state.dialogType}
              submitText={this.state.submitText}
              disabledInput={this.state.disabledInput}
              dialogTitle={this.state.dialogTitle}
            />
          </Modal>
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.dialogIsOpenVerDatos}
            onHide={this.handleDialogVerDatos}
            backdrop="static"
            keyboard="false"
          >
            <EmpresaDatos
              empresa={this.state.selectedEmpresa}
              handleClose={this.handleDialogVerDatos}
              type={this.state.dialogType}
              submitText={this.state.submitText}
              disabledInput={this.state.disabledInput}
              dialogTitle={this.state.dialogTitle}
            />
          </Modal>

          <Modal
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.dialogDesactivarEmpresa}
            onHide={() => this.handleDialogDesactivarEmpresa(false)}
            backdrop="static"
            keyboard="false"
          >
            <Container>
              <Modal.Body>
                <Row className="justify-content-center">
                  <Col className="text-center text-md-right">
                    <img
                      src={ExclamacionIcon}
                      style={{ margin: "40px" }}
                    ></img>
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col className="text-center text-md-right">
                    {this.state.selectedEmpresa.activo ? (
                      <p>
                        <strong>
                          Estas seguro que desea desactivar la empresa
                          seleccionada?
                        </strong>
                      </p>
                    ) : (
                      <p>
                        <strong>
                          Estas seguro que desea reactivar la empresa
                          seleccionada?
                        </strong>
                      </p>
                    )}
                  </Col>
                </Row>
                <Row style={{ background: "#EDF2F9" }}>
                  <Col>
                    <p>
                      <strong>Empresa:</strong>{" "}
                      {this.state.selectedEmpresa.nombre}
                    </p>
                    <p>
                      <strong>RUC:</strong> {this.state.selectedEmpresa.ruc}
                    </p>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => this.handleDialogDesactivarEmpresa(false)}
                  variant="contained"
                >
                  Cancelar
                </Button>
                <Button
                  onClick={() =>
                    this.handleDesactivarEmpresa(
                      this.state.selectedEmpresa,
                      !this.state.selectedEmpresa.activo
                    )
                  }
                  color="primary"
                  autoFocus
                >
                  Aceptar
                </Button>
              </Modal.Footer>
            </Container>
          </Modal>
*/}
          <header className="component-header">
            <div className="page-container">
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">Gestión de empresas</h1>
                  <p className="page-description">
                    Desde este menú puede gestionar las empresas registradas
                  </p>
                </div>

                <div className="head-actions">
                  <button
                    onClick={this.handleNewEmpresa}
                    className="btn-medium btn-primary"
                  >
                    <span className="material-symbols-outlined">business</span>{" "}
                    Nueva Empresa
                  </button>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container">
              <div className="component-table">
                <div className="component-pagination">
                  <div className="pagination-actions">
                    <form
                      className="search-form form"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div className="search-group">
                        <div className="input-icon">
                          <span className="material-symbols-outlined">
                            search
                          </span>
                        </div>
                        <input
                          type="search"
                          className="input-search"
                          placeholder="Buscar..."
                          value={this.state.search}
                          onChange={this.handleSearchChange}
                        />
                      </div>
                    </form>

                    <div className="pagination">
                      <span className="info-pages">
                        {this.state.totalCount === 0
                          ? "0"
                          : this.state.page * this.state.pageSize + 1}
                        -
                        {Math.min(
                          (this.state.page + 1) * this.state.pageSize,
                          this.state.totalCount
                        )}{" "}
                        de {this.state.totalCount}
                      </span>
                      <button
                        className={`btn-prev ${this.state.page === 0 ? "btn-disabled" : ""
                          }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                        disabled={this.state.page === 0}
                      >
                        <span className="material-symbols-outlined">
                          navigate_before
                        </span>
                      </button>
                      <button
                        className={`btn-next ${this.state.page >= this.state.totalPages - 1
                          ? "btn-disabled"
                          : ""
                          }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                        disabled={
                          this.state.page >= this.state.totalPages - 1
                        }
                      >
                        <span className="material-symbols-outlined">
                          navigate_next
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="responsive-table">
                  {this.state.loading ? (
                    <div className="loading-area">
                      <p>Cargando...</p>
                    </div>
                  ) : (
                    <table>
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Dirección</th>
                          <th>RUC</th>
                          <th>Estado</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.empresaData.empresas.length === 0 ? (
                          <tr>
                            <td colSpan="5">No se encontraron resultados</td>
                          </tr>
                        ) : (
                          this.props.empresaData.empresas.map(
                            (empresa, index) => (
                              <tr key={index}>
                                <td>{empresa.nombre}</td>
                                <td>{empresa.direccion}</td>
                                <td>{empresa.ruc}</td>
                                <td>
                                  {empresa.activo ? "Activo" : "Inactivo"}
                                </td>
                                <td>
                                  <div className="table-actions">
                                    <button
                                      className="table-icon"
                                      onClick={() => {
                                        this.props.history.push({
                                          pathname: '/admin/empresas/edit',
                                          state: {
                                            empresa: empresa
                                          }
                                        })
                                      }}
                                    >
                                      <img src={editIcon} alt="editar" />
                                    </button>

                                    <button
                                      className="table-icon"
                                      onClick={() => this.handleDialogVerDatos(true, empresa)}
                                    >
                                      <img src={visibility} alt="ver" />
                                    </button>
                                    <button
                                      className="table-icon"
                                      onClick={() => {
                                        this.setState(
                                          {
                                            dialogTitle: empresa.activo
                                              ? "Desactivar empresa"
                                              : "Reactivar empresa",
                                            selectedEmpresa: empresa,
                                            dialogType: "edit",
                                            submitText: "Aceptar",
                                            disabledInput: false,
                                          },
                                          () => {
                                            this.handleDialogDesactivarEmpresa(
                                              true
                                            );
                                          }
                                        );
                                      }}
                                    >
                                      <img
                                        src={
                                          empresa.activo
                                            ? doNotdisturb
                                            : restore
                                        }
                                        alt="estado"
                                      />
                                    </button>

                                  </div>
                                </td>
                              </tr>
                            )
                          )
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
          <ModalDetalleConfiguraciones
            ref={this.modalRef}
            abierto={this.state.dialogIsOpenVerDatos}
            onClose={() => this.handleDialogVerDatos(false)}
            titulo="Datos de la empresa"
            renderContenido={(datos) => (
              <div className="card">
                <p className="section__subtitle">
                  {" "}
                  {datos.nombre?.trim() || "--"}{" "}
                </p>

                <div className="card-content">
                  <div className="content-inner">
                    <span className="label"> Número de RUC </span>
                    <span className="txt">
                      {" "}
                      {datos.ruc?.trim() || "--"}{" "}
                    </span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Dirección </span>
                    <span className="txt">{datos.direccion?.trim() || "--"}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Estado </span>
                    <div className="row__labels">
                      {
                        datos.activo
                          ? (<span className="label__success"> Activo </span>)
                          : (<span className="label__warning"> Inactivo </span>)
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
          />
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getEmpresas: (page, size, search) =>
    dispatch(getEmpresas(page, size, search)),
});

const mapStateToProps = (state) => ({
  empresaData: state.empresaData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Empresas);
